export const maskCardNumber = (codigo, hasCartaoAdmin) => {
  if (!codigo && codigo !== 0) {
    return '';
  }
  const code = String(codigo);
  if (hasCartaoAdmin) {
    return code;
  }
  if (code.length <= 4) {
    return code;
  }
  return `*****${code.slice(-4)}`;
};
